import instance from "@/services/api";

export const shellProjectsAPI = {
  async getList(params = {}) {
    return await instance()
      .get("/floor_map/project/read/", { params })
      .then((res) => res?.data);
  },
  async updateShellProject(body) {
    return await instance()
      .post("/floor_map/project/upd/", body)
      .then((res) => res?.data);
  },
  async getProjectInfo(project_id) {
    return await instance()
      .get(`/floor_map/project/${project_id}/info/`)
      .then((res) => res?.data);
  },
  async updProjectInfo(body) {
    return await instance()
      .post(`/floor_map/project/info_upd/`, body)
      .then((res) => res?.data);
  },
  async getProjectTypes() {
    return await instance()
      .get("/floor_map/project/type/")
      .then((res) => res?.data);
  },
  async getEmployeeList() {
    return await instance()
      .get("/floor_map/project/employee_list/")
      .then((res) => res?.data);
  },
  async getEntrancesBlockInfo(project_id) {
    return await instance()
      .get(`/floor_map/project/${project_id}/blocks/`)
      .then((res) => res?.data);
  },
  async updEntrancesBlockInfo(body) {
    return await instance()
      .post(`/floor_map/project/blocks_upd/`, body)
      .then((res) => res?.data);
  },
  async getPerformersByProjectId(project_id) {
    return await instance()
      .get(`/floor_map/project/read_assign/project_id/${project_id}/`)
      .then((res) => res?.data);
  },
  async getAssignTypes() {
    return await instance()
      .get(`/floor_map/project/assign_type/`)
      .then((res) => res?.data);
  },
  async getContractors() {
    return await instance()
      .get(`/common/contractors/read/`)
      .then((res) => res?.data);
  },
  async getEmployeesListByContractorId(contractor_id) {
    // /common/employees/contractor_id/<int:contractor_id>/ get
    return await instance()
      .get(`/common/employees/contractor_id/${contractor_id}/`)
      .then((res) => res?.data);
  },
  async getPerformersBlockInfo(project_id) {
    return await instance()
      // .get(`/floor_map/project/${project_id}/blocks/`)
      .then((res) => res?.data);
  },
  async getProjectsById(project_id) {
    return await instance()
      .get(`/floor_map/project/${project_id}/projects_resident/`)
      .then((res) => res?.data);
  },
  async updateShellProjectPerfomancer(body) {
    return await instance()
      .post("/floor_map/project/assign_upd/", body)
      .then((res) => res?.data);
  },
  async copyPasteEntranceProperties(body) {
    return await instance()
      .post("/floor_map/project/dublicate_entrance/", body)
      .then((res) => res?.data);
  },
  async deleteShellProjectPerfomancer(body) {
    return await instance()
      .post(`/floor_map/project/assign_del/`, body)
      .then((res) => res?.data);
  },
};
